var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikkieLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 36,
    viewBox: "0 0 100 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M71.517 19.872c-.703 0-1.041-.309-1.041-1.004 0-.593.338-.953 1.04-.953l.027-.49c0-.283 0-.592.026-.9h-.052c-.703 0-1.041-.31-1.041-1.005 0-.592.338-.953 1.04-.953h.339a8.85 8.85 0 0 1 2.238-4.069c1.743-1.828 3.929-2.73 6.556-2.73 1.535 0 2.888.31 4.033.954 1.171.618 1.744 1.364 1.77 2.214 0 1.108-.703 2.112-1.718 2.138-.494.025-1.067-.18-1.717-.567-.65-.412-1.43-.618-2.342-.618-1.483 0-2.653.515-3.512 1.52-.286.36-.547.746-.729 1.158h3.981c.65 0 1.04.36 1.04.953 0 .695-.39 1.004-1.04 1.004H75.94c-.026.31-.052.618-.052.902v.49h3.018c.625 0 1.015.36 1.015.952 0 .695-.39 1.004-1.015 1.004h-2.602c.208.541.495 1.03.859 1.468.859 1.004 2.03 1.52 3.512 1.52.911 0 1.692-.206 2.342-.593.65-.412 1.223-.618 1.717-.592 1.015.026 1.718 1.056 1.718 2.112-.026.875-.599 1.622-1.77 2.266-1.145.618-2.498.927-4.033.927-2.627 0-4.813-.901-6.556-2.73-1.171-1.236-1.926-2.704-2.316-4.378h-.26z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "187.6%",
    height: "172.9%",
    x: "-31.3%",
    y: "-26%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M5.062 11.496H2.244C.834 11.496 0 10.756 0 9.389c0-1.394.834-2.135 2.244-2.135H12.51c1.41 0 2.244.74 2.244 2.107 0 1.395-.834 2.135-2.244 2.135h-2.79v13.208c0 1.965-.978 2.79-2.33 2.79-1.38 0-2.329-.825-2.329-2.79V11.496z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "194.9%",
    height: "169.2%",
    x: "-33.9%",
    y: "-24.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M19.07 7.254c1.351 0 2.329.826 2.329 2.79v14.66c0 1.965-.978 2.79-2.33 2.79-1.38 0-2.33-.825-2.33-2.79V10.3c0-2.306.95-3.046 2.33-3.046"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "400.5%",
    height: "169.2%",
    x: "-107.3%",
    y: "-24.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M29.423 19.523v5.181c0 1.965-.978 2.79-2.33 2.79-1.38 0-2.329-.825-2.329-2.79v-14.66c0-1.964.95-2.79 2.33-2.79 1.351 0 2.33.826 2.33 2.79v4.81l6.24-6.29c1.353-1.48 2.618-1.424 3.51-.712.92.712 1.15 2.164-.144 3.53l-6.241 5.807 6.672 6.149c.748.712 1.122 1.395 1.122 1.993 0 .597-.201 1.11-.575 1.537-.432.427-.95.626-1.553.626-.604 0-1.266-.341-1.985-1.053l-7.047-6.918z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: "188.5%",
    height: "169.2%",
    x: "-31.6%",
    y: "-24.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M48.004 19.523v5.181c0 1.965-.978 2.79-2.33 2.79-1.38 0-2.33-.825-2.33-2.79v-14.66c0-1.964.95-2.79 2.33-2.79 1.352 0 2.33.826 2.33 2.79v4.81l6.241-6.29c1.352-1.48 2.618-1.424 3.51-.712.92.712 1.15 2.164-.145 3.53l-6.24 5.807 6.672 6.149c.748.712 1.122 1.395 1.122 1.993 0 .597-.202 1.11-.576 1.537-.431.427-.949.626-1.553.626s-1.265-.341-1.984-1.053l-7.047-6.918z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: "188.5%",
    height: "169.2%",
    x: "-31.6%",
    y: "-24.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M64.255 7.254c1.352 0 2.33.826 2.33 2.79v14.66c0 1.965-.978 2.79-2.33 2.79-1.38 0-2.33-.825-2.33-2.79V10.3c0-2.306.95-3.046 2.33-3.046"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: "400.5%",
    height: "169.2%",
    x: "-107.3%",
    y: "-24.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40C4B8",
    d: "M82.03.043c-9.894 0-17.887 7.938-17.887 17.73 0 3.288.898 6.364 2.51 9.003v.526c0 6.004-4.457 7.949-4.457 7.949s6.3.066 9.635-2.859h.002c.03 0 .069-.042.111-.042.043 0 .081.042.111.042h.004c2.85 2.128 6.28 3.056 9.97 3.056 9.895 0 17.915-7.91 17.915-17.702 0-9.793-8.02-17.703-17.914-17.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60C6BA",
    d: "M81.745 1.107c9.714 0 17.616 7.653 17.901 17.199.005-.177.013-.354.013-.532C99.66 7.98 91.64.043 81.745.043 71.85.043 63.83 7.98 63.83 17.773c0 .21.004.419.011.627C64.077 8.81 72 1.107 81.745 1.107"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#l"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikkieLogo);
export default __webpack_public_path__ + "static/media/tikkie-logo.0d3e5b2f1fc7aa0ac9d3adb98d4071a2.svg";
export { ForwardRef as ReactComponent };